<template>
  <div class="animated fadeIn">
    <basic-heading title="Customers">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list customer'">
      <template #gated-content>
        <b-row class="px-0 m-0 bg-light my-3">
          <b-col
            v-for="(indicator, index) in indicators"
            :key="index"
            :class="`px-${index === 1 ? 3 : 0}`"
          >
            <indicator-tile
              :text="indicator.text"
              :indicator_key="indicator.indicator_key"
              :indicator_service="indicator.indicator_service"
              :faIcon="indicator.faIcon"
              :variant="indicator.variant"
            />
          </b-col>
        </b-row>
        <customer-server-table :show_columns="columns" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import StatisticTile from "@/components/shared/StatisticTile";
import CustomerServerTable from "@/components/crm/customer/CustomerServerTable";
import IndicatorTile from "@/components/shared/IndicatorTile";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { customer_indicators } from "@/shared/_indicators";

export default {
  name: "CustomerIndex",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    CustomerServerTable,
    IndicatorTile,
    PermissionAlertGate,
    StatisticTile,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/customer/add",
            title: "Add customer",
            variant: "success",
            permission: this.checkPermission("add customer"),
          },
        ],
      };
    },
  },
  data() {
    return {
      columns: [
        "full_name",
        "account_number",
        "primary_billing_location.city",
        "phone",
      ],
      indicators: customer_indicators,
    };
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
  },
};
</script>
